import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const SideBarWrapper = styled.div<{ topNavHeight: number }>`
  max-width: 230px;
  padding: ${tokens.spacer.x1pt5};
  border-right: 1px solid ${tokens.color.ui_border_light};
  padding-top: 30px;
  height: calc(100vh - ${({ topNavHeight }) => topNavHeight}px);
`;

// setting a margin directly on the SearchInput causes the clear button to be misaligned so we use a wrapper
export const SearchInputWrapper = styled.div`
  margin-bottom: ${tokens.spacer.x1};
`;
